<div class="container-xxl">
    <div class="authentication-wrapper authentication-basic container-p-y">
        <div class="authentication-inner">
            <div class="container">
                <mat-card class="center mt-3 col-md-offset">
                    <mat-card-title>
                        <h2 class="mt-3 mb-4">
                            Change Password </h2>
                    </mat-card-title>

                    <mat-card-content>
                        <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">

                            <!-- <label for="firstName" class="form-label">Email or Username</label> -->
                            <mat-form-field appearance="outline" class="form-field col-md-offset mb-3"
                                style="width:100%">
                                <mat-label>Enter Your UserName</mat-label>
                                <input matInput type="text" formControlName="email" name="email" id="email" required
                                    autofocus readonly="true">
                            </mat-form-field>

                            <!-- <label for="password" class=" form-label"> Old Password</label> -->
                            <mat-form-field appearance="outline" class="form-field col-md-offset mb-3"
                                style="width:100%">
                                <mat-label>Enter Old Password</mat-label>
                                <input matInput [type]="hide ? 'password' : 'text'" name="oldPassword"
                                    formControlName="oldPassword"
                                    [ngClass]="{'is-invalid':submitted && forms.oldPassword.errors}" required autofocus>
                                <mat-error *ngIf="submitted && forms.oldPassword.errors" class="invalid-feedback">
                                    <div *ngIf="forms.oldPassword.errors.required">Password is required</div>
                                    <div *ngIf="forms.oldPassword.errors.minlength"></div>
                                    <div class="error-text"
                                        *ngIf="forgotForm.get('oldPassword').hasError('passwordStrength')">
                                        {{forgotForm.get('oldPassword').errors['passwordStrength']}}
                                    </div>
                                </mat-error>

                                <button mat-icon-button matSuffix (click)="hide = !hide" type="button"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </button>
                            </mat-form-field>

                            <!-- <label for="password" class=" form-label">New Password</label> -->
                            <mat-form-field appearance="outline" class="form-field col-md-offset mb-3"
                                style="width:100%">
                                <mat-label>Enter New Password</mat-label>
                                <input matInput [type]="hideNew ? 'password' : 'text'" name="newPassword"
                                    formControlName="newPassword"
                                    [ngClass]="{'is-invalid':submitted && forms.newPassword.errors}" required autofocus>
                                <mat-error *ngIf="submitted && forms.newPassword.errors" class="invalid-feedback">
                                    <div *ngIf="forms.newPassword.errors.required">Password is required</div>
                                    <div *ngIf="forms.newPassword.errors.minlength"></div>
                                    <div class="error-text"
                                        *ngIf="forgotForm.get('newPassword').hasError('passwordStrength')">
                                        {{forgotForm.get('newPassword').errors['passwordStrength']}}
                                    </div>
                                </mat-error>
                                <button mat-icon-button matSuffix (click)="hideNew = !hideNew" type="button"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNew">
                                    <mat-icon>{{hideNew ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </button>
                            </mat-form-field>

                            <!-- <label for="password" class=" form-label">Confirm Password</label> -->
                            <mat-form-field appearance="outline" class="form-field col-md-offset mb-3"
                                style="width:100%">
                                <mat-label>Confirm Password</mat-label>
                                <input matInput [type]="hideConfirmNew ? 'password' : 'text'" name="confirmPassword"
                                    formControlName="confirmPassword"
                                    [ngClass]="{'is-invalid':submitted && forms.confirmPassword.errors}" required
                                    autofocus>
                                <mat-error *ngIf="submitted && forms.confirmPassword.errors" class="invalid-feedback">
                                    <div *ngIf="forms.confirmPassword.errors.required">Password is required</div>
                                    <div *ngIf="forms.confirmPassword.errors.minlength"></div>
                                    <div class="error-text"
                                        *ngIf="forgotForm.get('confirmPassword').hasError('passwordStrength')">
                                        {{forgotForm.get('confirmPassword').errors['passwordStrength']}}
                                    </div>
                                </mat-error>
                                <button mat-icon-button matSuffix (click)="hideConfirmNew = !hideConfirmNew"
                                    type="button" [attr.aria-label]="'Hide password'"
                                    [attr.aria-pressed]="hideConfirmNew">
                                    <mat-icon>{{hideConfirmNew ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </button>
                            </mat-form-field>
                            <alert></alert>
                            <div class="mb-3 password">
                                <div *ngIf="this.forgotForm.get('newPassword').invalid || this.forgotForm.get('confirmPassword').invalid">
                                    Password must contain all of the following:<br>
                                    Numbers, Lowercase letters,
                                    Uppercase letters, or special characters and must be at least 6 characters.
                                </div>
                            </div>
                            <mat-card-actions class="mt-3">
                                <!-- <a href="" class="col-md-5" style = "text-decoration: none;">Forgot Password?</a> -->
                                <button type="submit" class="btn btn-primary d-grid w-100 "> Submit </button>

                                <button class="btn btn-primary d-grid w-100 mt-3 mb-1"
                                    [routerLink]="'/All/dashboardCompo'">Cancel</button>
                            </mat-card-actions>
                        </form>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</div>